import { AbstractDestroyable } from '@deqo/foundation';
import { injectable } from 'inversify';
import { Component } from '../../../concepts/objects';
import { KeyInput } from '../../../platform/input/KeyInput';
import { MouseInput } from '../../../platform/input/MouseInput';
import { WheelInput } from '../../../platform/input/WheelInput';
import { CursorValue } from '../Cursor';
import { KeyMappings } from './KeyMappings';

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */

export type ToolSettings = Readonly<Record<string, any>>;

export const ToolSettings = Object.freeze({
    fromStyleProperties(component: Component): ToolSettings {
        const desc = Component.describe(component);
        const props = desc.properties.filter(x => !!x.style);
        const settings = {} as Record<string, any>;
        for (const p of props) {
            settings[p.name] = component.get(p.name);
        }
        return settings as ToolSettings;
    },
    setStylePropertiesViaSettings(oneOrManyComponents: Component | Component[], settings: ToolSettings) {
        const arr = Array.isArray(oneOrManyComponents) ? oneOrManyComponents : [oneOrManyComponents];
        for (const c of arr) {
            const desc = Component.describe(c);
            const props = desc.properties.filter(x => !!x.style);
            for (const p of props) {
                const value = settings[p.name];
                if (value !== undefined) {
                    c.set(p.name, value);
                }
            }
        }
    }
});

@injectable()
export class ToolBehavior extends AbstractDestroyable {

    public init(settings: ToolSettings, param: any): string | void { }

    public getKeyMappings(): KeyMappings { return []; }

    public getPreferredCursor(state: string, e: MouseInput | KeyInput): CursorValue | void { }

    public onMouseDown(state: string, e: MouseInput): string | void { }

    public onMouseMove(state: string, e: MouseInput): string | void { }

    public onMouseUp(state: string, e: MouseInput): string | void { }

    public onMouseEdge(state: string, e: MouseInput): string | void { }

    public onClick(state: string, e: MouseInput): string | void { }

    public onDoubleClick(state: string, e: MouseInput): string | void { }

    public onKeyDown(state: string, e: KeyInput): string | void { }

    public onKeyUp(state: string, e: KeyInput): string | void { }

    public onWheel(state: string, e: WheelInput): string | void { }

    public onStateChanged(newState: string, oldState: string): void { }
}
